import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router"
import styled from "styled-components"
import FormMgtSensor from './FormMgtSensor'
import TableMgtParameters from "./TableMgtParameters"

import actions from "../../redux/actions"
import ServiceParameter from '../../service/Mgt-sensor-parameter'
import AuthService from '../../service/Auth'

const Container = styled.div`
    width: 100%;
    .map{
        height: 300px;
        & > * {
            width: 100%;
        }
    }

    .form-container{
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
        @media only screen and (min-width : 1200px) {
            width: 60%;
        }

        @media only screen and (max-width:768px){
            width: 60%;
        }
        @media only screen and (max-width : 450px){
            width: 100%;
        }

    }
`;

export default function Index(props) {
    const { sensorId } = useParams()
    const [permissionSensor, setPermissionSensor] = useState('')
    const [permissionParameter, setPermissionParameter] = useState('')
    const [parameterData, setParameterData] = useState([])
    const [filterParameterData, setFilterParameterData] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.master.setPath("/mgt-sensor"))
        const init = async () =>{
            let permissionSensor = await AuthService.permission('mgt-sensor')
            if(permissionSensor) setPermissionSensor(permissionSensor)
            let permissionParameter = await AuthService.permission('mgt-parameter')
            if(permissionParameter) setPermissionParameter(permissionParameter)
            await refresh()  
        }

        init()
    }, [dispatch])

    const refresh = async () =>{
        if(!sensorId) return
        let data = await ServiceParameter.searchBySensorId(sensorId)
        if (data) { setParameterData(data)}    
    }

    return (
        <Container>
            <div className="page-title">
                <img src='/image/sensor.png' alt="icon-sensor"/>
                <span>จัดการเซนเซอร์</span>
            </div>
            <div className="form-container">
                <div className="section-heading">
                    <span>ข้อมูลเซนเซอร์</span>
                </div>
                <FormMgtSensor sensorId={sensorId} permission={permissionSensor}/>
            </div>
            <div className="table-container" >
            {sensorId ? <TableMgtParameters
                    permission={permissionParameter}
                    sensorId = {sensorId}                    
                    fncRefresh={refresh}
                    data={parameterData} 
                    fncSetData={setParameterData} 
                    filterData={filterParameterData} 
                    fncSetFilterData={setFilterParameterData}/> 
            : <></>}               
            </div>
        </Container>
    )
}
